import { isString } from 'lodash-es';

import { useHoneycombDatasetType } from './use-honeycomb-dataset-type.js';
import { buildRgbaColorWithOpacity } from '../../core/utils/build-rgba-color-with-opacity.js';
import { useDisplayConfig } from '../components/canvas/context/use-display-config.js';
import { HOVERED_TILE_OPACITY } from '../constants.js';
import type { HoneycombTileData } from '../types/honeycomb.js';
import { calculateTileOpacity } from '../utils/calculate-tile-opacity.js';

export const useFillColorByHoverState = (
  data: HoneycombTileData,
  baseColor: string,
) => {
  const { hovered } = useDisplayConfig();
  const datasetType = useHoneycombDatasetType();

  const isCategorical = datasetType === 'categorical';
  const opacity =
    isCategorical && isString(data.value)
      ? calculateTileOpacity(hovered, data.value)
      : HOVERED_TILE_OPACITY;

  return buildRgbaColorWithOpacity(baseColor, opacity);
};
